import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

// Lleva al catálogo de follaje con scroll suave (respeta prefers-reduced-motion).
// El ancla nativa (#catalogo) queda como fallback accesible si JS no interviniera.
const irAlCatalogo = (e) => {
    const destino = document.getElementById('catalogo');
    if (!destino) return; // deja que el navegador resuelva el ancla por defecto
    e.preventDefault();
    const reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    destino.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
};

const IntroFollajeArtificial = () => {
    return (
        <section className="about-service pb-0">
            <div className="container">
                <div className="row align-items-center mt-n1-9">
                    <div className="col-lg-6 mt-1-9">
                        <div className="pe-lg-6 pe-xl-15">
                            <div className="title-style2 mb-2-2 wow fadeIn" data-wow-delay="200ms">
                                <h2 className="h1">Follaje artificial para muros verdes</h2>
                            </div>
                            <p className="text-secondary text-uppercase font-weight-800 mb-1-9">
                                Verde todo el año, sin agua ni mantenimiento
                            </p>
                            <p className="mb-1-9">
                                El follaje artificial de Decototal recrea la apariencia de un muro verde natural
                                con materiales pensados para durar: HDPE con filtro UV, LDPE y poliéster, según el
                                acabado y el uso que le quieras dar. Es una alternativa práctica para ambientar
                                oficinas, restaurantes, comercios y espacios residenciales sin depender del riego,
                                la poda o el clima.
                            </p>
                            <p className="mb-2-9">
                                Distribuimos follaje en panel, rollo y formato expandible, en presentaciones 3D,
                                Premium, Estándar, paneles de flores y lona decorativa, con entrega inmediata
                                sobre pedido.
                            </p>

                            {/* Botón que lleva al usuario al catálogo de modelos */}
                            <div className="mb-6 wow fadeInUp" data-wow-delay="400ms">
                                <a
                                    href="#catalogo"
                                    className="butn-style7 rounded"
                                    onClick={irAlCatalogo}
                                >
                                    Ver catálogo
                                </a>
                            </div>

                            <div className="w-xl-90 w-xxl-100 mb-6">
                                <BannerNoInstalacion />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-1-9">
                        <div>
                            <div className="row align-items-center">
                                <div className="col-6">
                                    <div>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/assets/img/productos/follaje-artificial/follaje-artificial-intro-der.jpg`}
                                            alt="Muro verde con follaje artificial Decototal"
                                            className="rounded"
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/assets/img/productos/follaje-artificial/follaje-artificial-intro-izq.jpg`}
                                            alt="Detalle de panel de follaje artificial"
                                            className="mb-sm-4 rounded"
                                        />
                                        <div className="bg-dark p-1-6 p-md-1-9 d-none d-sm-block rounded">
                                            <h5 className="mb-0 text-white">Interior y exterior</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IntroFollajeArtificial;